import { kavaProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/kava/default-constants';

export const SURFDEX_CONTRACT_ADDRESS = '0x4310ed61E7E4fd50C2b44C92725C087abeB632a2';

export const SURFDEX_PROVIDER_CONFIGURATION = kavaProviderConfiguration;
